




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { formatNum, genConfig } from '../../render';
import { IConfigV2, ITimeParsed, ITimeType } from '../../types';
import { IActions, IStats } from '@/store/home/stats/types';
import HomeWidgetCard from '@/views/home/common/Card.vue';
import DpgIncrementChart from './DpgIncrementChart.vue';
import DpgIncrementTable from './DpgIncrementTable.vue';

const Stats = namespace('home/stats');

// 专案组及样板间新增统计
@Component({
  components: { HomeWidgetCard, DpgIncrementChart, DpgIncrementTable },
})
export default class DpgIncrement extends Vue {
  @Stats.Action('queryDpgIncrementStats') public queryStats!: IActions['queryDpgIncrementStats'];
  @Stats.State('dpgIncrementStats') public stats!: IStats;

  @Stats.Action('queryDpgIncrementList') public queryList!: IActions['queryDpgIncrementList'];
  @Stats.Action('saveWidgetConfig') public saveConfig!: IActions['saveWidgetConfig'];

  @Prop() public code!: string;
  @Prop() public title!: string;
  @Prop() public userId!: number;
  @Prop() public configId!: number;
  @Prop() public config!: IConfigV2;

  public expanded = false;
  public updatedPeriod: ITimeType = '';
  public updatedTimes: ITimeParsed | null = null;

  public get colNum() {
    return this.config?.cols || 6;
  }

  // 已保存的时间配置
  public get times() {
    const period = this.config?.period || '';
    const startTime = this.config?.startTime || '';
    const endTime = this.config?.endTime || '';
    const isInterval = period === 'interval';
    return isInterval ? { period, startTime, endTime } : { period, startTime: '', endTime: '' };
  }

  // 生成配置字符串
  public get configStr() {
    const period = this.updatedPeriod || this.config.period || '';
    const startTime = this.updatedTimes?.startTime || this.config.startTime || '';
    const endTime = this.updatedTimes?.endTime || this.config.endTime || '';
    const obj = genConfig({ ...this.config, period, startTime, endTime });
    return JSON.stringify(obj);
  }

  // 保存接口入参
  public get saveParams() {
    const widgetCode = this.code;
    const userId = this.userId || null;
    const configId = this.configId || null;
    const baseConfig = configId ? { configId, widgetCode } : { widgetCode };
    return (!!userId && !!widgetCode) ? { userId, configs: [{ ...baseConfig, config: this.configStr }] } : null;
  }

  // 统计数据
  public get items() {
    return this.stats.data.map((item) => ({ text: item.dataName, value: formatNum(item.aggNum || 0) }));
  }

  // 时间变化时触发(初始化会触发)
  public onTimeChange(period: ITimeType, parsedTime: ITimeParsed) {
    const params = { startTime: parsedTime.startTime, endTime: parsedTime.overTime };
    this.updatedPeriod = period;
    this.updatedTimes = parsedTime;
    this.queryStats(params);
    if (this.expanded) {
      this.queryList(params);
    }
  }

  // 展开或收起
  public onExpandPanel(expanded: boolean, parsedTime: ITimeParsed) {
    this.expanded = expanded;
    if (expanded) {
      this.queryList({ startTime: parsedTime.startTime, endTime: parsedTime.overTime });
    }
  }

  // 保存设置
  public onSaveSettings() {
    if (this.saveParams) {
      this.saveConfig(this.saveParams);
    }
  }
}
